<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('shapeLinks.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('shapeLinks.edit.title') }}
        </h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-shape-links-new' }"
        >
          {{ $t('shapeLinks.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <shape-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import ShapePage from '../components/ShapePage.vue';

export default {
  name: 'shape-links-edit',
  components: {
    ShapePage,
  },
  methods: {
    ...mapActions(['setToggle', 'getShapeLinks']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getShapeLinks(this.$route.params.puzzleId);
    }
  },
};
</script>
